import Block from '../block'

export default class Form extends Block {
	static title = 'form'

	init() {
		this.errorElement = this.element.querySelector('.message--error')
		this.autoSubmitElements = this.element.querySelectorAll(
			'input[type="radio"], select, input[type="checkbox"]'
		)

		if (this.hasModifier('autosubmit')) {
			this.autoSubmitElements.forEach(submitElement => {
				submitElement.addEventListener('change', () => {
					this.element.submit()
				})
			})
		}

		if (this.hasModifier('payment')) {
			this.element.addEventListener('submit', e => {
				this.termsConditionChecked(e)
				this.privacyChecked(e)
			})
		}
	}

	termsConditionChecked(e) {
		if (
			this.element.querySelector('#agree') &&
			!this.element.querySelector('#agree').checked
		) {
			e.preventDefault()
			if (this.errorElement) {
				this.errorElement.classList.add('message--visible')
			}
		}
	}

	privacyChecked(e) {
		if (
			this.element.querySelector('#privacy') &&
			!this.element.querySelector('#privacy').checked
		) {
			e.preventDefault()
			if (this.isValidBlock(this.errorElement)) {
				this.errorElement.classList.add('message--visible')
			}
		}
	}
}
